import EmptyLeg from 'pages/home/components/EmptyLeg';
import React, { useEffect } from 'react';

import LeftLogoSVG from 'assets/imgs/svg/home/fly-airtaxi-left.svg';
import RightLogoSVG from 'assets/imgs/svg/home/fly-airtaxi-right.svg';
import Footer from 'components/layout/Footer';
import styled from 'styled-components';
import Banner from './components/Banner';
import Blog from './components/Blog';
import Membership from './components/Membership';
// import PetFriendlyFlights from './components/PetFriendlyFlights';
import Testimonial from './components/Testimonial';

import { HomeMain } from './Home.style';

export const BannerSection = styled.div`
  --banner-height: 80vh;
  @media (max-width: 737px) {
    --banner-height: 497px;
  }
  position: relative;
  height: var(--banner-height);
`;

const BackgroundSection = styled.div`
  @media (min-width: 1600px) {
    background: ${(props) =>
      props.$left
        ? `#fff url(${LeftLogoSVG}) no-repeat left top`
        : `#fff url(${RightLogoSVG}) no-repeat right top`};
  }
`;

export const LogoContainer = styled.div`
  padding: 16px 40px;
  background: #0e1e36;
  display: flex;
  justify-content: center;
`;

export const LogoImg = styled.img`
  max-width: 1300px;
`;

const Home = () => {
  useEffect(() => {
    console.log(`v${process.env.REACT_APP_VERSION || '2.9.1.8-09.21'}`);
  }, []);

  return (
    <HomeMain>
      <BannerSection>
        <Banner />
      </BannerSection>
      <LogoContainer>
        <LogoImg src={`${process.env.REACT_APP_ASSET_URL}/logos/logos.webp`} alt="logos"></LogoImg>
      </LogoContainer>

      <BackgroundSection>
        {/* <PetFriendlyFlights /> */}
        <EmptyLeg />
      </BackgroundSection>

      <Membership />
      <BackgroundSection $left>
        <Testimonial />
        <Blog />
      </BackgroundSection>

      <Footer />
    </HomeMain>
  );
};

export default Home;
